import { render } from "./MediaManager.vue?vue&type=template&id=1b966ee4"
import script from "./MediaManager.vue?vue&type=script&lang=js"
export * from "./MediaManager.vue?vue&type=script&lang=js"

import "./MediaManager.vue?vue&type=style&index=0&id=1b966ee4&lang=scss"

import exportComponent from "c:\\Clients\\VoterFly\\application\\VoterFly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__